






















import {Component, Vue, Prop, Emit} from 'vue-property-decorator';
import OutstandingInput from "@/components/outstanding/Input.vue";
import OutstandingResult from "@/components/outstanding/Result.vue";
import OutstandingApi from "@/consoleapi/api/outstanding";

import {mapGetters} from "vuex";

@Component({
    components: {
        OutstandingInput,
        OutstandingResult,
    },
    computed:
        mapGetters({
            progress:'outstanding/progress'
        }),
})

export default class Outstanding extends Vue {
    email: string | null = null;

    @Prop() bearerToken!: string;
    @Prop() accountId!: string;
    @Prop() userId!: string;
    @Prop() outstandingInvoiceId!: string;

    public taxExclusion = 0;
    public tax = 0;
    public taxIncluded = 0;
    public date = '';

    mounted(): void {
        const outstandingApi = new OutstandingApi();
        outstandingApi.setBearerToken(this.bearerToken);
        outstandingApi.show(this.accountId, this.outstandingInvoiceId).then(response => {
            const invoice = response.data.invoice;
            const outstandingInvoice = response.data.outstandingInvoice;
            // console.log(response.data);
            this.taxExclusion = invoice.tax_exclusion;
            this.tax = invoice.tax;
            this.taxIncluded = invoice.tax_included;
            this.date = invoice.target_date;
        }).catch(error => {
            // console.log(error.response);
            this.$router.push('/');
        });
    }

    public getOutstandingInvoiceId(inputOutstandingInvoiceId: string) {
        this.inputOutstandingInvoiceIdEmit(inputOutstandingInvoiceId);
    }

    @Emit()
    public inputOutstandingInvoiceIdEmit(inputOutstandingInvoiceId: string) {
        // console.log('Emit2=>' + inputOutstandingInvoiceId);
    }

    private get inputOutstandingInvoiceId(): string {
        return this.outstandingInvoiceId;
    }

    private set inputOutstandingInvoiceId(outstandingInvoiceId: string) {
        this.inputOutstandingInvoiceIdEmit(outstandingInvoiceId);
    }
}
